/* 🤖 this file was generated by svg-to-ts */
export const DfIconDartSquare16: {
  name: 'dart-square-16';
  data: string;
} = {
  name: 'dart-square-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm6.743 3.754a1.875 1.875 0 0 0-.49.848l-.071.273-.334.193a3 3 0 1 0 2.246 3.897l.338-.196.27.073c.32.086.652.085.966.003A4.5 4.5 0 0 1 2.75 8a4.5 4.5 0 0 1 5.993-4.246zm.015 4.252a1.5 1.5 0 1 1-.747-1.298l1.333-.77a.375.375 0 0 0 .175-.228l.192-.726a.375.375 0 0 1 .173-.227l1.666-.975a.375.375 0 0 1 .542.45l-.285.798a.375.375 0 0 0 .286.495l.849.154a.375.375 0 0 1 .122.693l-1.679.982a.375.375 0 0 1-.286.038l-.721-.194a.375.375 0 0 0-.285.037l-1.335.771z" fill-rule="evenodd"/></svg>`
};
